import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.afterservice.user.as.apply');
import { OnInit, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import moment from 'moment';

@Component({
    selector: 'wiz-portal-afterservice-user-as-apply',
template: templateSource || '',
    styles: [``],
})
export class PortalAfterserviceUserAsApplyComponent implements OnInit {

    @ViewChild('modalMessage') modalMessage: any;
    @Input() title: any;

    public data: any = {};
    public list: any = {};
    public options: any[] = [];

    constructor(@Inject( Router)         private router: Router,@Inject( Service    )         public service: Service    ) {}

    async ngOnInit() {
        await this.service.init();
        await this.init();
        await this.service.render();
    }

    public async register() {

        const payload = JSON.parse(JSON.stringify(this.list));

        const res = await wiz.call('insert', payload);

        if (res.code === 200) {
            await this.showModal("A/S가 접수 되었습니다.");
            this.router.navigate(['/user/as/list']);
        }
    }

    public async init() {

        const res = await wiz.call('init');

        if (res.code === 200) {

            const initModel = res.data.repeat[0];

            this.data = res.data;
            this.options = res.data.repeat || [];

            this.list = this.data.models[initModel] || {};
            this.list.model = initModel;

            this.formatInstalled();
        }
    }

    private formatInstalled() {

        if (this.list?.installed) {
            this.list.installed = moment(this.list.installed)
                .format("YYYY-MM-DD HH:mm");
        }
    }

    private async showModal(message: string): Promise<void> {
        await this.modalMessage.open({ message });
    }

    public async selectModel(model: string) {

        this.list = this.data.models[model] || {};
        this.list.model = model;

        this.formatInstalled();
        await this.service.render();
    }

    public mobileFormat() {

        if (!this.list.mobile) return;

        let mobile = this.list.mobile;

        mobile = mobile
            .replace(/[^0-9]/g, "")
            .replace(
                /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,
                "$1-$2-$3"
            )
            .replace("--", "-");

        this.list.mobile = mobile;
    }
}

export default PortalAfterserviceUserAsApplyComponent;